import { render, staticRenderFns } from "./EventCreate.vue?vue&type=template&id=0bbd7882&scoped=true&"
import script from "./EventCreate.vue?vue&type=script&lang=js&"
export * from "./EventCreate.vue?vue&type=script&lang=js&"
import style0 from "./EventCreate.vue?vue&type=style&index=0&id=0bbd7882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd7882",
  null
  
)

export default component.exports